import type { QueryRollupLevelOption } from "./types";

// Safety-net catalogue rendered while `finpubQueryLevels` is in flight, or if
// that query fails or returns nothing, so the Levels dropdown is never empty.
// The data-service is the source of truth; keep this list aligned with its
// curated `_QUERY_LEVEL_OPTIONS`.
export const FALLBACK_QUERY_ROLLUP_LEVEL_OPTIONS: readonly QueryRollupLevelOption[] = [
  { value: "entity", label: "Entity" },
  { value: "account", label: "Account" },
  { value: "position", label: "Position" },
  { value: "deal", label: "Deal" },
  { value: "transaction", label: "Transaction" },
];
